import { render, staticRenderFns } from "./ActionsCardServiam.vue?vue&type=template&id=83e57e0c&scoped=true&"
import script from "./ActionsCardServiam.vue?vue&type=script&lang=js&"
export * from "./ActionsCardServiam.vue?vue&type=script&lang=js&"
import style0 from "./ActionsCardServiam.vue?vue&type=style&index=0&id=83e57e0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e57e0c",
  null
  
)

export default component.exports